export async function extractPdfPreview(
  file: File
): Promise<{ thumbBlob: Blob; pageCount: number } | null> {
  try {
    const pdfjs = await import('pdfjs-dist');
    pdfjs.GlobalWorkerOptions.workerSrc = new URL(
      'pdfjs-dist/build/pdf.worker.min.mjs',
      import.meta.url
    ).toString();

    const data = await file.arrayBuffer();
    const pdf = await pdfjs.getDocument({ data }).promise;
    const pageCount = pdf.numPages;
    const page = await pdf.getPage(1);
    const viewport = page.getViewport({ scale: 0.5 });
    const canvas = document.createElement('canvas');
    canvas.width = viewport.width;
    canvas.height = viewport.height;
    const ctx = canvas.getContext('2d');
    if (!ctx) return { thumbBlob: new Blob(), pageCount };

    await page.render({ canvasContext: ctx, viewport }).promise;
    const thumbBlob = await new Promise<Blob>((resolve, reject) => {
      canvas.toBlob(
        (blob) => (blob ? resolve(blob) : reject(new Error('Failed to render PDF preview'))),
        'image/jpeg',
        0.85
      );
    });
    return { thumbBlob, pageCount };
  } catch {
    return null;
  }
}
